"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Info;

var _Info = require("@adobe/react-spectrum-workflow/dist/Info");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Info(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Info.A4uInfo, null));
}